<div class="campanha-recurso-view">   
    <div class="campanha-recurso-view-header">       
        <div class="row">
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Total dos Investimentos / Produtos / Serviços</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">R$</span>
                    </div>
                    <input type="text" class="form-control text-right" value="{{recursoForm?.valorTotal | decimalFormat: 1:2:2}}" disabled="disabled" readonly="readonly">
                </div> 
                <p class="form-text">Valor total dos investimentos, produtos e serviços desta campanha</p>
            </div>
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Total das Bonificações / Amostras</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">R$</span>
                    </div>
                    <input type="text" class="form-control text-right" value="{{valorTotalPedidosBonificacoes | decimalFormat: 1:2:2}}" disabled="disabled" readonly="readonly">
                </div>  
                <p class="form-text text-muted">
                    Valor total bonificado/amostra nesta campanha
                </p>                       
            </div>
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Total dos Recursos</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">R$</span>
                    </div>
                    <input type="text" class="form-control text-right" value="{{valorTotalDespesas| decimalFormat: 1:2:2}}" disabled="disabled" readonly="readonly">
                </div>  
                <p class="form-text text-muted">
                    Valor total dos recursos desta campanha
                </p>                       
            </div>
        </div>
    </div>

    <div class="campanha-recurso-view-body">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link active" data-target="#tabRecursosRecursos" data-toggle="tab">Investimentos / Produtos / Serviços</a>
            </li>        
            <li class="nav-item">
                <a class="nav-link" data-target="#tabRecursosBonificacoes" data-toggle="tab" (click)="onTableResultadoBonificacoesClick()">Bonificações / Amostras</a>
            </li>
        </ul>

        <div class="tab-content">   
            <div class="tab-pane active" id="tabRecursosRecursos">
                <sgt-recurso-campanha-form
                    #recursoForm
                    [isShowValorTotal]="false"
                    [idArea]="idArea"
                    [recursos]="recursos"
                    [canEdit]="false">
                </sgt-recurso-campanha-form>
            </div>

            <div class="tab-pane tab-pane-bonificacoes" id="tabRecursosBonificacoes">
                <sgt-campanha-pedido-view
                    #resultadoBonificacoes
                    [idCampanha]="idCampanha"
                    [filter]="filter"
                    [objetivoBonificacao]="true"
                    [showStatusMetas]="!isStatusEmAnalise"
                    [showStatusNaoLiberado]="isStatusEmAnalise">
                </sgt-campanha-pedido-view> 
            </div>
        </div>
    </div>    
</div>